<template>
  <footer class="footer padding-vertical-5x">
    <div class="site-container site-container-lg">
      <div class="row row--gutters">
        <div class="col-xs-12 col-sm-12 col-md-4 col-md--order-2">
          <section class="font-size-12 footer-left">
            <anchor href="/" class="logo"><img src="https://storage.googleapis.com/assets.festfoods.com/images/logo/header.svg" onerror="this.src='https://storage.googleapis.com/assets.festfoods.com/images/logo/header.png';this.onerror=null;" alt="Festival Foods"></anchor>
            <p class="margin-top-2x">
              More than just a grocery store. As an employee- and family-owned company, we pride ourselves on providing high quality products and offering our guests an exceptional shopping experience.
            </p>
            <p class="margin-top-2x">
              &copy; <span id="copyright-year"></span> Festival Foods
            </p>
            <div class="margin-top-2x social-icons">
              <anchor href="https://www.facebook.com/festfoods">
                <icon name="Facebook" size="34" />
                <span class="accessibly-hidden">Facebook</span>
              </anchor>
              <anchor href="https://instagram.com/festfoods/">
                <icon name="Instagram" size="34" />
                <span class="accessibly-hidden">Instagram</span>
              </anchor>
              <anchor href="https://www.pinterest.com/festfoods/">
                <icon name="Pinterest" size="34" />
                <span class="accessibly-hidden">Pinterest</span>
              </anchor>
              <anchor href="https://twitter.com/festfoods">
                <icon name="Twitter" size="34" />
                <span class="accessibly-hidden">Twitter</span>
              </anchor>
              <anchor href="https://www.youtube.com/user/skogensfestivalfoods">
                <icon name="YouTube" size="34" />
                <span class="accessibly-hidden">Youtube</span>
              </anchor>
            </div>
          </section>
        </div>
        <div class="col-xs-12 col-md-8 col-md--order-1 flex-center">

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    copyright () {
      const date = new Date()
      const year = date.getFullYear()
      const copyright = document.querySelector('#copyright-year')

      copyright.textContent = year
    }
  },
  mounted () {
    this.copyright()
  }
}
</script>

<style lang="scss">
  .footer {
    background-color: $gray-light;

    a {
      color: $black;
      text-decoration: none;

      &:hover {
        color: $green;

        .accessible & {
          color: $green-accessible;
        }
      }
    }

    .btn--ghost {
      cursor: pointer;
      display: inline-block;
      border: .1rem solid $black;
      padding: .5rem;
    }

    &-left {
      @include breakpoint-min(md) {
        border-right: .1rem solid $black;
      }
    }

    &-nav {
      @include breakpoint-min(md) {
        padding: 0 0 0 2rem;
      }
      font-size: $s14;
      padding: 0;
      width: 100%;

      a {
        display: block;
        padding: 0 0 2rem;
      }
    }
  }

  .social-icons {
    display: flex;
    justify-content: space-between;
    max-width: 26rem;
    width: 100%;

    svg {
      transition: fill .3s;
    }

    a {
      display: inline-block;

      &:hover {
        svg {
          fill: darken($green, 5%);

          .accessible & {
            fill: darken($green, 5%);
          }
        }
      }
    }
  }
</style>
